import germany from '../img/Germany.png';
import france from '../img/France.png';
import Spain from '../img/Spain.png';
import Italy from '../img/Italy.png';
import Netherland from '../img/Netherland.png';

export const cityName = [
  'London', 'Liverpool', 'Leeds', 'Manchester', 'Lester',
  'Berlin', 'Hamburg', 'Mainz', 'Leipzig', 'Brunswick',
  'Lille', 'Paris', 'Lyon', 'Marseille', 'Nantes',
  'Barcelona', 'Madrid', 'Sevilla', 'Toledo', 'Bilbao',
  'Milan', 'Lecce', 'Florence', 'Venice', 'Naples',
  'Almere', 'Tilburg', 'Enschede', 'Doetinchem', 'Weert',
];

export const countyName = [
  {
    name: 'France',
    icon: france,
  },
  {
    name: 'Germany',
    icon: germany,
  },
  {
    name: 'Spain',
    icon: Spain,
  },
  {
    name: 'GreatBritain',
    icon: 'https://www.linkpicture.com/q/Greatbritain.png',
  },
  {
    name: 'Netherland',
    icon: Netherland,
  },
  {
    name: 'Italy',
    icon: Italy,
  },
];
